import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmOrganizationDetailsRoute: InvariantJiraRoute = {
	name: 'csm-organization-details',
	path: '/jira/customer-service-management/organizations/:organizationId',
	exact: true,
};
